import { useTranslation } from 'react-i18next';
import type { PriceLabelInfoModel } from 'autogen/swagger/all';
import { useGetForFixedLowPriceQuery } from 'autogen/swagger/all/hooks';
import { GeneralExceptionError } from 'autogen/translation-keys/trans-website-shared-error';
import toast from 'components/Toast';
import useMediatorState, { mediatorAtom } from 'hooks/globals/useMediatorAtom';

type PriceLabelInfoState = { isOpen: boolean; priceLabelInfo?: PriceLabelInfoModel };

export const priceLabelInfoState = mediatorAtom<PriceLabelInfoState>({
    isOpen: false
});

export default function usePriceLabelInfo() {
    const { refetch: fetchFixedLowPriceInfo } = useGetForFixedLowPriceQuery({ enabled: false });
    const [, toggle] = useMediatorState(priceLabelInfoState);
    const { t } = useTranslation();

    function openInfo(type) {
        switch (type) {
            case 'FixedLowPrice':
                fetchFixedLowPriceInfo({ throwOnError: true })
                    .then((data) => toggle({ isOpen: true, priceLabelInfo: data.data }))
                    .catch(() => {
                        toast.error(t(GeneralExceptionError));
                    });
                break;
            default:
                // Default
                break;
        }
    }

    return openInfo;
}
